import LocalStorageService from '../Services/localstorage';
import { load } from './FavoriteProducts.action';

export const FAVORITE_ICON_ADD = 'FAVORITE_ICON_ADD';
export const FAVORITE_ICON_REMOVE = 'FAVORITE_ICON_REMOVE';

export const toggleFavorite = (articleNumber, event) => (dispatch, getState) => {    
    if(!articleNumber){
        return
    }
    var exists = LocalStorageService.valueExistInArray("favoriteProducts", articleNumber);
    LocalStorageService.toggleValueInArray("favoriteProducts", articleNumber);
    if (exists) {
        dispatch(remove(articleNumber));
    } else {
        dispatch(add(articleNumber));
    }
    event.preventDefault();
    dispatch(load());
}

export const add = articleNumber => ({
    type: FAVORITE_ICON_ADD,
    payload: articleNumber,
})

export const remove = articleNumber => ({
    type: FAVORITE_ICON_REMOVE,
    payload: articleNumber,
})

